import { Backup, Refresh, Monitor, Security } from "@mui/icons-material";
import { Drawer, List, ListItem, ListItemIcon, ListItemText, Divider } from "@mui/material";
import React from "react";
import { WSIcons } from "../../commonFunctions/iIcons";

export const BackendSettings:React.FC<any>=React.memo(({open,onClose})=>{
    return(
        <Drawer anchor="right" open={open} onClose={onClose}>
         <List sx={{ width: 250 ,mt:7}}>
         <ListItem button>
            <ListItemIcon>
              <WSIcons.SettingsIcon />
            </ListItemIcon>
            <ListItemText primary="Settings" />
          </ListItem>
          <ListItem button>
            <ListItemIcon>
              <WSIcons.ToolsIcon />
            </ListItemIcon>
            <ListItemText primary="Option" />
          </ListItem>
          <ListItem button>
            <ListItemIcon>
              <WSIcons.GTranslateIcon />
            </ListItemIcon>
            <ListItemText primary="Refresh Language" />
          </ListItem>
          <Divider />
          <ListItem button>
            <ListItemIcon>
              <WSIcons.BackupIcon />
            </ListItemIcon>
            <ListItemText primary="Database Backup" />
          </ListItem>
          <ListItem button>
            <ListItemIcon>
              <WSIcons.RestoreIcon />
            </ListItemIcon>
            <ListItemText primary="Database Restore" />
          </ListItem>

          <ListItem button>
            <ListItemIcon>
              <WSIcons.SplitIcon />
            </ListItemIcon>
            <ListItemText primary="Split Database" />
          </ListItem>
          <ListItem button>
            <ListItemIcon>
              <WSIcons.RefreshIcon />
            </ListItemIcon>
            <ListItemText primary="Refresh default Data" />
          </ListItem>
          <ListItem button>
            <ListItemIcon>
              <Monitor />
            </ListItemIcon>
            <ListItemText primary="Database Monitoring" />
          </ListItem>
          <ListItem button>
            <ListItemIcon>
              <WSIcons.BackupIcon />
            </ListItemIcon>
            <ListItemText primary="Auto Backup Schedule Task" />
          </ListItem>
          <Divider />

          <ListItem button>
            <ListItemIcon>
              <WSIcons.ChecklistIcon />
            </ListItemIcon>
            <ListItemText primary="Night Audit" />
          </ListItem>
          <ListItem button>
            <ListItemIcon>
              <WSIcons.ChecklistIcon />
            </ListItemIcon>
            <ListItemText primary="Multi Outlet Night Audit" />
          </ListItem>
          <ListItem button>
            <ListItemIcon>
              <WSIcons.UndoIcon />
            </ListItemIcon>
            <ListItemText primary="Undo Night Audit" />
          </ListItem>
          <Divider/>
          <ListItem button>
            <ListItemIcon>
                <WSIcons.RocketLaunchIcon/>
            </ListItemIcon>
            <ListItemText primary="Product Tour" />
          </ListItem>

          <ListItem button>
            <ListItemIcon>
                <WSIcons.QuestionAnswerIcon/>
            </ListItemIcon>
            <ListItemText primary="Freq. Asked Que." />
          </ListItem>

          <ListItem button>
            <ListItemIcon>
              <WSIcons.SupportAgentIcon />
            </ListItemIcon>
            <ListItemText primary="Live Support" />
          </ListItem>

          <ListItem button>
            <ListItemIcon>
                <WSIcons.FeedbackIcon/>
            </ListItemIcon>
            <ListItemText primary="Feedback" />
          </ListItem>

          <ListItem button>
            <ListItemIcon>
                <WSIcons.VerifiedUserIcon/>
            </ListItemIcon>
            <ListItemText primary="License" />
          </ListItem>

          <ListItem button>
            <ListItemIcon>
                <WSIcons.PhonelinkRingIcon/>
            </ListItemIcon>
            <ListItemText primary="Mobile Devices" />
          </ListItem>

          <Divider />

          <ListItem button>
            <ListItemIcon>
                <WSIcons.ContactPhoneIcon/>
            </ListItemIcon>
            <ListItemText primary="Contact Us" />
          </ListItem>

          <ListItem button>
            <ListItemIcon>
                <WSIcons.LocalLibraryIcon/>
            </ListItemIcon>
            <ListItemText primary="About Us" />
          </ListItem>

          <Divider />

         
        </List>
      </Drawer>
    )
})